import React, { useState, useEffect } from 'react';
import cn from 'classnames'
import styles from './styles.module.css'

// СЫРОЙ КОМПОНЕНТ 26.08.25 )
const currencyFormatter = new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency: 'RUB',
    minimumFractionDigits: 2
});

const CurrencyInput = ({ value, onChange, className, title, ...props }) => {
    const [displayValue, setDisplayValue] = useState(value);
    const selectClassObject = cn(
        styles.customSelect, className,
        // { [styles.error]: error !== 0 || error }
    )
    // Синхронизация с внешним значением (для контролируемого режима)
    useEffect(() => {
        if (value !== undefined) {
            const number = parseInt(value?.toString().replace(/[^0-9]/g, ''), 10);
            setDisplayValue(
                !isNaN(number) ? currencyFormatter.format(number / 100) : ''
            );
        }
    }, [value]);

    const handleInput = (e) => {
        const inputValue = e.target.value;
        const number = parseInt(inputValue.replace(/[^0-9]/g, ''), 10);

        const newValue = !isNaN(number)
            ? currencyFormatter.format(number / 100)
            : '';

        setDisplayValue(newValue);
        if (onChange) {
            const centsValue = !isNaN(number) ? number : 0;
            onChange(centsValue);
        }
    };

    const handleKeyDown = (e) => {
        if (!/[0-9]|Backspace|ArrowLeft|ArrowRight|Delete|Tab|Enter/.test(e.key)) {
            e.preventDefault();
        }
    };

    return (
        <div className={selectClassObject}>
            <p>{title}</p>
            <input
                {...props}
                type="text"
                value={displayValue}
                onInput={handleInput}
                onKeyDown={handleKeyDown}
                placeholder=""
                className={styles.input}
            />
        </div>
    );
};

const MoneyInput = ({ setFieldValue, value, name, title }) => {

    const handleCurrencyChange = (fieldName) => (value) => {
        setFieldValue(fieldName, value);
    };

    return (
        <CurrencyInput
            className="currency-input"
            onChange={handleCurrencyChange(name)}
            value={value}
            name={name}
            title={title}
        />
    );
};

export default MoneyInput;